import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1324709679169511';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Injects the Meta (Facebook) Pixel and fires the initial PageView.
 * Renders nothing — mount it once near the root of the app.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-284">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-285" />
    </noscript>;
}
/**
 * Safely fires a Meta Pixel "InitiateCheckout" conversion event.
 * Call this from any button/link that sends the user to the cart.
 */
export function trackInitiateCheckout(params: {
  content_name: string;
  value: number;
  currency?: string;
}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'InitiateCheckout', {
    content_name: params.content_name,
    value: params.value,
    currency: params.currency ?? 'ARS'
  });
}